import { useState } from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { motion } from "framer-motion";
import two_happy_woman from "../../../images/two_happy_woman.jpg";
import two_happy_face from "../../../images/tewo_woman_face.jpg";
import { EmotionPredictionTable, EmotionPredictionList } from '../../PredictionResultTable/PredictionResultTable';
import image1 from "../../../images/happy_woman_one.png";
import image2 from "../../../images/happy_woman_two.png";
import image3 from "../../../images/happy_woman_three.png";
import ai_analysis from "../../../images/Emotion_analysis.png";
import discussion from "../../../images/discussion.png";
import ai_thinking from "../../../images/AI_thinking.png";
import ai_idea from "../../../images/ai_idea.png";

export default function StudyOneInstructionPageTwo(){
        const googleDriveVideoIds = ["1Ymv-dAWCsZn69nl7hu41srB4rwNjIn6R",
    ];
    const [connecting, setConnecting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState(["", "", ""]);

    const handleAnalyzeClick = () => {
        setConnecting(true);
        setResults(["", "", ""]);

        setTimeout(() => {
            setConnecting(false);
            setLoading(true);

            setTimeout(() => {
                setLoading(false);
                setResults(["Fear: 95.7%", "Happy: 99.4%", "Happy: 99.9%"]);
            }, 1500);
        }, 1500);
    };
    const [showBubble, setShowBubble] = useState(false);

    const handleImageClick = () => {
        setShowBubble(true);
    };
    return (
        <Container className="study-item">
            <Row>
                <h1 style={{ fontWeight: 'bold'}}>Did her emotion change?</h1>
                <Container style={{width:"90%"}}>
                    <Row>
                        <p>EmoAI followed her with a series of snapshots...</p>
                    </Row>

                    <Row>
                            {googleDriveVideoIds.map((videoId, index) => (
                                <Col  className="text-center mb-4 video-wrapper">
                                    <iframe
                                        src={`https://drive.google.com/file/d/${videoId}/preview`}
                                        allow="autoplay"
                                        className="video-iframe"
                                        style={{ width: "100%", height: "auto" }}
                                    ></iframe>
                                </Col>
                            ))}
                    </Row>

                    
                    <Row className="text-center mb-3">
                        {[image1, image2, image3].map((imgSrc, idx) => (
                            <Col key={idx}>
                                <img
                                    src={imgSrc}
                                    alt={`Snapshot ${idx + 1}`}
                                    style={{
                                        width: "200px",
                                        height: "200px",
                                        objectFit: "cover",
                                    }}
                                />
                            </Col>
                        ))}
                    </Row>

                    <Row className="text-center mb-4">
                        {results.map((result, idx) => (
                            <Col key={idx} style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                                {result}
                            </Col>
                        ))}
                    </Row>


                    <Row className="text-center mb-5">
                        <Col>
                            <motion.button 
                                onClick={handleAnalyzeClick} 
                                disabled={connecting || loading}
                                className="button analyze-button"
                                title="Analyze Now!"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.8 }}
                            >
                                {connecting ? (
                                    <>
                                        <Spinner animation="grow" size="sm" /> Connecting to EmoAI...
                                    </>
                                ) : loading ? (
                                    <>
                                        <Spinner animation="border" size="sm" /> Analyzing...
                                    </>
                                ) : (
                                    "Analyze Emotion Changes"
                                )}
                            </motion.button>
                        </Col>
                    </Row>
                    <Row className="align-items-start mb-4">
                                <Col xs={4} className="text-center">
                                    <img 
                                        src={ai_idea} 
                                        alt="FEAI icon" 
                                        style={{ width: "150px", height: "150px", }} 
                                        onClick={handleImageClick}
                                    />
                                </Col>
                                <Col xs={6}>
                                {showBubble && (
                                <div className="chat-bubble">
                                    <p>
                                    <strong className="highlight">Head angle and obstructions</strong> impact the results!
                                    </p>
                                </div>
                                )}
                                </Col>
                        </Row> 
                   
                </Container>
            </Row>
        </Container>
    );
};